import { format } from "date-fns";

export const now = () => format(new Date(), "yyyy-MM-dd HH:mm:ss");

export const autoFormatNPWP = (NPWPString) => {
    try {
        const cleaned = ("" + NPWPString).replace(/\D/g, "");
        const match = cleaned.match(
            /(\d{0,3})?(\d{0,3})?(\d{0,3})?(\d{0,1})?(\d{0,3})?(\d{0,3})$/
        );
        return [
            match[1],
            match[2] ? "." : "",
            match[2],
            match[3] ? "." : "",
            match[3],
            match[4] ? "." : "",
            match[4],
            match[5] ? "-" : "",
            match[5],
            match[6] ? "." : "",
            match[6],
        ].join("");
    } catch {
        return "";
    }
};

export const generateCaptcha = () => Math.random().toString(36).slice(8);

export const initialTrader = {
    JENIS_USAHA: "",
    NOMOR_KUSUKA: null,
    NAMA: null,
    NPWP: null,
    NO_IZIN: null,
    ALAMAT: null,
    PROPINSI: null,
    KOTA: null,
    KODEPOS: null,
    TELEPON: null,
    EMAIL: null,
    EMAIL_PNBP: null,
    KETERANGAN: null,
    TGL_DAFTAR: now(),
    FILE_ID: "",
    STATUS: "0",
    LAST_UPDATED: now(),
};

export const initialUser = {
    ROLE: "4",
    KODE_TRADER: 0,
    USERNAME: "",
    PASSWORD: null,
    JNS_ID: "1",
    NO_ID: "",
    NAMA: "",
    ALAMAT: "",
    EMAIL: "",
    TELEPON: "",
    JABATAN: "",
    KD_UNIT: "1",
    STATUS: "1",
    STS_LOGIN: "0",
    DATE_LOGIN: now(),
    IP_LOGIN: "",
    LAST_LOGIN: now(),
    DATE_CREATED: now(),
    USER_CREATED: 1,
    LAST_UPDATED: now(),
    USER_UPDATED: 1,
};

// utils/registerUtils.js
export const USERNAME_REGEX = /^[a-z0-9][a-z0-9_.]*$/;

export const sanitizeUsername = (value) =>
    (value || "").replace(/\s/g, "").toLowerCase();

export const usernameRules = (username = "") => {
    return {
        minLength: username.length >= 5,
        startWithLetterOrDigit: /^[a-z0-9]/.test(username),
        validChars: /^[a-z0-9_.]*$/.test(username),
        noSpace: !/\s/.test(username),
    };
};

export const isValidUsername = (username) => {
    const r = usernameRules(username);
    return r.noSpace && r.minLength && r.startWithLetterOrDigit && r.validChars;
};

export const onlyDigits = (value) => (value || "").replace(/\D/g, "");